import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useSpreadBellStore = defineStore('spread-bell', () => {
  const spread = ref<number | null>(null)
  const backSpread = ref<number | null>(null)

  function cleanState() {
    spread.value = null
    backSpread.value = null
  }

  function setSpread(v: number | null) {
    spread.value = v
  }

  function setBackSpread(v: number | null) {
    backSpread.value = v
  }
  return { spread, backSpread, cleanState, setSpread, setBackSpread }
})
